import React from "react";
import { assignToListIconRed, assignToListIcon } from "../../Components";
import { InfluencerRating } from "../../Components";

export default function ShowOfferDetails({ user, offerDetails }) {
  console.log("🚀 ~ ShowOfferDetails ~ offerDetails:", offerDetails);
  // const handleOffersPlatform = (platform) => {
  //   if (platform == "IG") {
  //     return (
  //       <img
  //         src="images/instagram.png"
  //         width="28"
  //         title="instagram"
  //         className="smallImg"
  //       />
  //     );
  //   }
  //   if (platform == "FB") {
  //     return (
  //       <img
  //         src="images/facebook.png"
  //         width="28"
  //         title="facebook"
  //         className="smallImg"
  //       />
  //     );
  //   }
  //   if (platform == "TT") {
  //     return (
  //       <img
  //         src="images/tiktok.png"
  //         width="28"
  //         title="tiktok"
  //         className="smallImg"
  //       />
  //     );
  //   }
  //   if (platform == "YT") {
  //     return (
  //       <img
  //         src="images/youtube.png"
  //         width="28"
  //         title="youtube"
  //         className="smallImg"
  //       />
  //     );
  //   }
  // };

  const handleOffersPlatform = (socialMediaCode) => {
    if (!socialMediaCode || typeof socialMediaCode !== "object") return null;

    const platformIcons = {
      IG: { src: "images/instagram.png", title: "Instagram" },
      FB: { src: "images/facebook.png", title: "Facebook" },
      TT: { src: "images/tiktok.png", title: "TikTok" },
      YT: { src: "images/youtube.png", title: "YouTube" },
    };

    return Object.entries(socialMediaCode)
      .filter(([_, value]) => value) // keep only true ones
      .map(([key]) => {
        const icon = platformIcons[key];
        if (!icon) return null;

        return (
          <img
            key={key}
            src={icon.src}
            width="28"
            title={icon.title}
            alt={icon.title}
            className="smallImg"
          />
        );
      });
  };

  return (
    <>
      {offerDetails && (
        <>
          <div className="">
            {offerDetails && (
              <div>
                <div className="campaignsInfluItem__head searchcontainer offerDetailsProfile">
                  <div className="cardMain">
                    {user?.active_role == 3 && (
                      <div className="top-icons">
                        <div className="social-icons">
                          {/* {offerDetails?.account?.map((item) => {
                            if (item?.account_type == "Instagram") {
                              return (
                                <img
                                  src="images/instagram.svg"
                                  width="28"
                                  title="instagram"
                                  className="smallImg"
                                />
                              );
                            }
                            if (item?.account_type == "Facebook") {
                              return (
                                <img
                                  src="images/facebook.svg"
                                  width="28"
                                  title="instagram"
                                  className="smallImg"
                                />
                              );
                            }
                            if (item?.account_type == "TikTok") {
                              return (
                                <img
                                  src="images/tiktok-logo.svg"
                                  width="28"
                                  title="instagram"
                                  className="smallImg"
                                />
                              );
                            }
                            if (item?.account_type == "Youtube") {
                              return (
                                <img
                                  src="images/youtube.svg"
                                  width="28"
                                  title="instagram"
                                  className="smallImg"
                                />
                              );
                            }
                          })} */}
                          {offerDetails?.to_social_platforms &&
                            handleOffersPlatform(
                              offerDetails?.to_social_platforms
                            )}
                        </div>
                        <div className="like-icon">
                          {offerDetails?.to_list_id
                            ? assignToListIconRed
                            : assignToListIcon}
                        </div>
                      </div>
                    )}
                    {user?.active_role == 1 ? (
                      <div
                        className="image-wrapper"
                        style={{
                          marginTop: "0px",
                          backgroundImage:
                            offerDetails?.brandDetails?.photo == ""
                              ? `url( ${process.env.PUBLIC_URL}/images/placeholder/avatar.png)`
                              : `url(${offerDetails?.from_profile_img_url})`,
                        }}
                      >
                        {" "}
                      </div>
                    ) : (
                      <div
                        className="image-wrapper"
                        style={{
                          marginTop: "30px",
                          backgroundImage:
                            offerDetails.profile_img == ""
                              ? `url( ${process.env.PUBLIC_URL}/images/placeholder/avatar.png)`
                              : `url(${offerDetails.to_profile_img_url})`,
                        }}
                      >
                        {" "}
                      </div>
                    )}
                    <div className="rating">
                      <div className="star-container " data-rating="0">
                        <InfluencerRating infrating={offerDetails?.to_rating} />
                      </div>
                    </div>
                    {user?.active_role == 1 ? (
                      <div className="username">
                        {offerDetails?.from_displayname}
                      </div>
                    ) : (
                      <div className="username">
                        {offerDetails?.to_displayname}
                      </div>
                    )}
                  </div>

                  <div
                    className={
                      user?.active_role == 3
                        ? "campaignsInfluItem__head-content offerDetailsContent"
                        : "campaignsInfluItem__head-content offerDetailsContent offerDetailsBrand"
                    }
                  >
                    <h4>Offer Details</h4>
                    <div className="campaignsInfluItem__head-row profile-container">
                      <div className="inner-packages">
                        <div className="package">
                          <div className="packge-head-wrap">
                            {(offerDetails?.social_media_code == "IG" ||
                              offerDetails?.platformname == "IG") && (
                              <img
                                src="images/instagram.png"
                                width="28"
                                title="instagram"
                                className="smallImg"
                              />
                            )}
                            {(offerDetails?.social_media_code == "FB" ||
                              offerDetails?.platformname == "IG") && (
                              <img
                                src="images/facebook.png"
                                width="28"
                                title="instagram"
                                className="smallImg"
                              />
                            )}
                            {(offerDetails?.social_media_code == "TT" ||
                              offerDetails?.platformname == "IG") && (
                              <img
                                src="images/tiktok.png"
                                width="28"
                                title="instagram"
                                className="smallImg"
                              />
                            )}
                            {(offerDetails?.social_media_code == "TY" ||
                              offerDetails?.platformname == "IG") && (
                              <img
                                src="images/youtube.png"
                                width="28"
                                title="instagram"
                                className="smallImg"
                              />
                            )}
                            <h2>{offerDetails?.description}</h2>
                            <div className="price divForastrictForPrice">
                              ${offerDetails?.price}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
